import { Box, type BoxProps } from "@mui/material";

export function Body({ children, sx, ...rest }: BoxProps) {
	return (
		<Box
			sx={{
				display: "flex",
				flex: 1,
				flexDirection: "column",
				gap: { xs: 1, lg: 2 },
				...sx,
			}}
			{...rest}
		>
			{children}
		</Box>
	);
}
